import React from "react";
import Highcharts from "highcharts/highcharts-gantt";
import HighchartsReact from "highcharts-react-official";
export const GanttChart2 = () => {
  const options = {
    title: {
      text: "",
     
    },
    chart: {
      height: 300,
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      enabled: false,
    },
    plotOptions: {
      series: {
        point: {
          events: {
            click: function () {
              if (this.options.url) {
                window.open(this.options.url, '_blank'); 
              }
            },
          },
        },
      },
    },
    xAxis: [
      {
        tickInterval: 1000 * 60 * 60 * 24 * 30, // Month
        labels: {
          format: "{value:%b}",
          style: {
            fontSize: "14px",
            backgroundColor: "#E5E5F2",
            color: "#4C44D8",
            borderColor: "rgba(0,0,0,0.3)",
          },
        },
        min: Date.UTC(2023, 0, 1),
        max: Date.UTC(2023, 12, 0),
        currentDateIndicator: false,
      },
    ],

    yAxis: {
      type: "category",
      grid: {
        enabled: true,
        borderColor: "rgba(0,0,0,0.3)",
        borderWidth: 1,
        columns: [
          {
            title: {
              text: "Country",
            },
            labels: {
              format: "{point.name}",
              style: {
                fontSize: "14px",
                backgroundColor: "red",
              },
            },
          },
          {
            title: {
              text: "Production(M60KgBg)",
            },
            labels: {
              format: "{point.production}",
            },
          },
        ],
      },
    },
    series: [
      {
        name: "Harvest Period",
        dataLabels: {
          verticalAlign: "top",
          inside: false,
        },
        data: [
          {
            start: Date.UTC(2023, 2, 1),
            end: Date.UTC(2023, 6, 31),
            y: 0,
            color: "#52A353",
            name: "Brazil",
            production:"17 (27.06 %)",
            url: "https://dialogochino.net/en/agriculture/380847-climate-change-poses-threats-to-brazils-coffee-growers/ "
          },
          {
            start: Date.UTC(2023, 9, 0),
            end: Date.UTC(2023, 11, 31),
            y: 1,
            name: "Vietnam",
            color: "#52A353",
            production: "29.75 (5.19 %)",
            url: "https://www.channelnewsasia.com/business/vietnam-jan-sept-coffee-exports-down-73-y-y-127-million-tonnes-statistics-office-3807606 "

          },
          {
            start: Date.UTC(2023, 0, 0),
            end: Date.UTC(2023, 0, 31),
            y: 1,
            color: "#52A353",
            name: "Vietnam",
            production: "29.75 (5.19 %)",
            url: "https://www.channelnewsasia.com/business/vietnam-jan-sept-coffee-exports-down-73-y-y-127-million-tonnes-statistics-office-3807606"
          },
          {
            start: Date.UTC(2023, 5, 1),
            end: Date.UTC(2023, 11, 31),
            y: 2,
            color: "#52A353",
            name: "Indonesia",
            production: "10.5 (20 %)",
            url: "https://www.globenewswire.com/news-release/2023/09/01/2735968/0/en/Certified-Coffee-Demand-on-the-Rise-Insights-into-Raw-Coffee-Beans-Market.html "
          },
          {
            start: Date.UTC(2023, 2, 0),
            end: Date.UTC(2023, 5, 30),
            y: 3,
            color: "#F1D500",
            name: "Uganda",
            production: "5.5 (24.54%)",
            url: " https://www.pulse.ug/business/coffee-exporters-earnings-shoot-up/mqxzbp6"
          },
          {
            start: Date.UTC(2023, 8, 1),
            end: Date.UTC(2023, 11, 31),
            y: 3,
            color: "#52A353",
            name: "Uganda",
            production: "5.5 (24.54%)",
            url: "https://www.pulse.ug/business/coffee-exporters-earnings-shoot-up/mqxzbp6"
          },
        ],
      },
    ],
  };
  return (
    <HighchartsReact
      highcharts={Highcharts}
      constructorType={"ganttChart"}
      options={options}
    />
  );
};
